import type { WalletProvider } from '@/extensions/snk/lib/device-utils';
import type { GlobalFooterRegionKey } from '@/extensions/snk/lib/global-footer';
import { cn } from '@/lib/utils';
import type { ComponentWithComponentData } from '@/lib/page-designer/component-loader.server';
import { DownloadApp, LinkColumns, NewsletterForm, PaymentMethods, SocialMediaIcons } from './ui';
import { Separator } from '@/components/ui/separator';

export type GlobalFooterRegions = Record<
    GlobalFooterRegionKey,
    Promise<ComponentWithComponentData | null> | ComponentWithComponentData | null
>;

export interface GlobalFooterProps {
    footerRegions: GlobalFooterRegions;
    mobileAppStorePlatform: WalletProvider;
    className?: string;
}

export const GlobalFooter = ({ footerRegions, mobileAppStorePlatform, className }: GlobalFooterProps) => {
    const borderClasses = 'border-primary-foreground border-t';
    const gridSeparatorClasses = `${borderClasses} md:hidden`;

    return (
        <footer data-slot="global-footer" className={cn('mt-auto bg-primary', className)}>
            <div className="flex flex-col px-4 py-6 md:px-12 md:py-8">
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 pb-6 md:pb-8">
                    <NewsletterForm />
                    <Separator className={gridSeparatorClasses} />
                    <DownloadApp mobileAppStorePlatform={mobileAppStorePlatform} />
                    <Separator className={gridSeparatorClasses} />
                    <SocialMediaIcons component={footerRegions.socialMediaIcons} />
                    <Separator className={gridSeparatorClasses} />
                    <PaymentMethods component={footerRegions.paymentMethodIcons} />
                </div>

                <Separator className={borderClasses} />
                <LinkColumns footerRegions={footerRegions} />
            </div>
        </footer>
    );
};
